<template>
  <div class="box">
    <Row>
      <Col span="6">
      <div class="title">
        城市轨道交通运营管理实验平台
      </div>
      </Col>
      <Col span="18">
      <Menu mode="horizontal" theme="light" active-name="1" @on-select="turnUrl">
        <MenuItem name="1" to="/">
        首页
        </MenuItem>
        <MenuItem name="2" to="/online/index">
        在线实验
        </MenuItem>
        <MenuItem name="3" to="/video/index">
        在线视频
        </MenuItem>
        <MenuItem name="tupu">
        知谱百科
        </MenuItem>
      </Menu>
      </Col>
    </Row>

  </div>
</template>

<script>
export default {
  name: "HeaderLayout",
  components: {},
  data() {
    return {};
  },
  created() {
    // if (sessionStorage.userInfo) {
    //   this.userInfo = JSON.parse(sessionStorage.userInfo);
    // }
  },
  computed: {},
  methods: {
    turnUrl(name) {
      if(name==='tupu'){
        window.open("http://ydkg.yoodao.net");
      }
      // this.$router.push(name);
    },
  },
  mounted() {
    // this.messageList = [...this.messageBaseList];
    // this.followList = [...this.followBaseList];
    // this.todoList = [...this.todoBaseList];
  },
};
</script>
<style lang="less" scoped>
.box {
  width: 1200px;
  margin: 0 auto;
  .title {
    font-size: 18px;
    color: red;
    font-weight: bold;
  }
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  color: red;
  border-bottom: 3px solid red;
}
.ivu-menu-item {
  font-size: 16px;
}
.ivu-menu-horizontal .ivu-menu-item,
.ivu-menu-horizontal .ivu-menu-submenu {
  padding: 0 30px;
}
.ivu-menu-horizontal.ivu-menu-light:after {
  height: 0;
}
.ivu-menu-horizontal {
  height: 64px;
  line-height: 64px;
}
</style>
